import { InfoBoxWithBackground } from "components/common/InfoBoxWithBackground";
import * as React from "react";
import { ui, pr } from "aaa";

export const SavingsOptionsInfoBox = ({ children, style }: { children: React.ReactNode, style?: React.CSSProperties }) => (
    <InfoBoxWithBackground
        borderColor="#135EE2"
        backgroundColor={ui.isDarkMode ? undefined : "#E7EFFD"}
        iconSize={16}
        iconColor="#135EE2"
        style={{ color: "#0A285C", fontSize: 14, ...pr.STYLE_CENTERED_CARD, ...style }}
    >
        {children}
    </InfoBoxWithBackground>
);


// WEBPACK FOOTER //
// ./src/components/savingsOptions/components/SavingsOptionsInfoBox.tsx